export default {
  setInfos (state, infos) {
    state.infos = infos
  },

  setInfo (state, info) {
    state.info = info
  },

  setContent (state, content) {
    state.content = content
  }
}
